module.exports = __webpack_public_path__ + "static/media/success-capture-3.b76901e4.png";